var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "booking-done",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.completeBooking"),
        width: "800px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            }
          }
        },
        [
          _c(
            "template",
            { slot: "up" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { "min-height": "200px" },
                attrs: {
                  "grid-options": _vm.up.gridOptions,
                  "column-defs": _vm.up.columnDefs,
                  "row-data": _vm.up.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.up.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "down" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { "min-height": "200px" },
                attrs: {
                  "grid-options": _vm.down.gridOptions,
                  "column-defs": _vm.down.columnDefs,
                  "row-data": _vm.down.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.down.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Close")))]
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }